import { ADD_PARAMETER_GOI003 } from 'types/actions';

export const AddParameters = element => ({
  type: ADD_PARAMETER_GOI003,
  element,
});
